<template>
    <div class="px-0" style="min-height: 100%; display: flex;">
        <Sidebar v-if="isSidebarActive" :settings="allSettings" :leadData="leadData" @menuOptionSelected="handleClickMenu" @updateSettings="handleUpdateSettings" />
        <Container :settings="allSettings" ref="containerComponent" @menuOptionSelected="handleClickMenu" @updateSettings="handleUpdateSettings" :key="allSettings.container.currentKey" :maskedPhoneNumber="maskedPhoneNumber" :uid="uid" />
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { scrollToTop } from '@/utils/scroll.js';
import { isMobileScreen } from '@/utils/device.js';
import { PRODUCT_ROUTE_SLUGS } from '@/constants/product-mappings.js';
import Sidebar  from './refresh-application/Sidebar.vue';
import Container from './refresh-application/Container.vue';

const props = defineProps({
    uid: {
        type: String,
        required: false,
    },
    leadData: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const maskedPhoneNumber = ref(props.leadData ? props.leadData.cell_phone : null);

const allSettings = ref({
    sidebar: {
        isActive: false,
        firstLoadWasAttempted: false,
    },
    container: {
        currentKey: 0,
        showOtherOffers: false,
        title: null,
    },
    isPhoneConfirmed: false,
    hasFailedPhoneConfirmation: false,
    phoneConfirmationMaxFailedAttempts: 3,
    selectedProduct: null,
    isMobile: true,
    newApplicationUrl: '/loan',
    memberPortalUrl: 'https://compare.loanscanada.ca/',
});

const containerComponent = ref(null);

const isSidebarActive = computed(() => {
    return allSettings.value.isPhoneConfirmed && allSettings.value.sidebar.isActive;
});

onMounted(() => {
    allSettings.value.isMobile = isMobileScreen();
    allSettings.value.sidebar.isActive = isSidebarActive.value;
});

function handleClickMenu(option) {
    allSettings.value.container.title = null;
    if (allSettings.value.isMobile) {
        handleToggleSidebar(false);
    }

    scrollToTop();

    switch (option) {
        case 'product_selection':
            allSettings.value.selectedProduct = null;
            allSettings.value.container.showOtherOffers = false;
            break;
    }
}

function handleToggleSidebar(status) {
    allSettings.value.sidebar.isActive = !!status;
}

function handleUpdateSettings(updates) {
    for (const [key, value] of Object.entries(updates)) {
        if (typeof value === 'object' && value !== null && typeof allSettings.value[key] === 'object') {
            Object.assign(allSettings.value[key], value);
        } else {
            allSettings.value[key] = value;
        }
    }
}

function setNewApplicationUrl() {
    allSettings.value.newApplicationUrl = `/${PRODUCT_ROUTE_SLUGS[allSettings.value.selectedProduct] ?? 'loan'}`;
}
</script>

<style scoped>

</style>
